module.exports = __webpack_public_path__ + "img/checkbox_on.1bbb94d3.svg";